import { connect } from 'react-redux';
import { auth, annotation as annotationHelpers } from './../helpers';
import { annotation as annotationSelectors } from './../selectors';
import {
  annotations as annotationActions,
  modal as modalActions
} from './../actions';

import BuildHealthFeedbackComponent from './../Components/BuildHealthFeedbackComponent';

export const mapStateToProps = (state, ownProps) => {
  const feedbackScoresByDispatcherIds =
  annotationSelectors.getFeedbackScoresByDispatcherIdsByBuildIds(
    state)[ownProps.buildId] || {};
  const annotationsByDispatcherIds =
  annotationSelectors.getAnnotationsByExtraInfoByTypedId(
    state,
    annotationHelpers.EXTRA_INFO_PROPS.DISPATCHER_ID,
    annotationHelpers.BUILD_TYPED
  )[ownProps.buildId] || {};
  const votingResults = feedbackScoresByDispatcherIds[ownProps.dispatcherId] ||
  { upVotes: 0, downVotes: 0, voteTotal: 0 };
  const usersVoteAnnotation = annotationHelpers.
    getUserAnnotation(annotationsByDispatcherIds[ownProps.dispatcherId]);
  const props =
  {
    buildId: ownProps.buildId,
    dispatcherId: ownProps.dispatcherId || 0,
    isDisabled: !ownProps.buildId || !ownProps.dispatcherId || !auth.checkAuthenticated(),
    upVoteCount: votingResults.upVotes,
    downVoteCount: votingResults.downVotes,
    voteTotal: votingResults.voteTotal,
    currentVote: usersVoteAnnotation
  };

  return props;
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onVoteClick: (vote, usersVoteAnnotation) => {
      const userName = localStorage.getItem('userName') || '';
      //check incoming vote against existing vote
      if (usersVoteAnnotation.status !== 'None') {
        dispatch(annotationActions.removeBuildComment(usersVoteAnnotation.id));
      }

      if (vote !== usersVoteAnnotation.status) {
        dispatch(annotationActions.addBuildComment(
          ownProps.annotatedItem,
          {
            user: userName,
            status: vote,
            'extra_info':
            {
              'dispatcher_id': ownProps.dispatcherId,
              'dispatcher_type': ownProps.dispatcherType
            }
          }
        ));
      }
    },
    onCommentClick: () =>
      dispatch(modalActions.showAddComment(
        true, ownProps.annotatedItem, ownProps.dispatcherId, ownProps.dispatcherType)),
  };
};

const BuildHealthFeedbackContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(BuildHealthFeedbackComponent);


export default BuildHealthFeedbackContainer;


// WEBPACK FOOTER //
// src/Containers/BuildHealthFeedbackContainer.jsx